export function getServer() {
    // NOTE that this is .hostname which CUTS OFF the port, so :3000 will disappear.
    return `https://${window.location.hostname}`
}
